import {getHomepage, getHomepageGifts, getPost} from './homepage';

export const apiHomepage = {
  getHomepage,
  getHomepageGifts,
  getPost,
};
